module.exports = __webpack_public_path__ + "img/a6.b9ecd2f5.svg";